/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-01 11:03:01
 * @LastEditors: linxi
 * @LastEditTime: 2023-12-15 11:17:12
 */
import React from 'react'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../../../app/store'
import { sendAsync } from '../../../../app/applicationSlice'
import { getSaveAiSettings, getSelectAiSettings, SaveAiSettingParams } from '../../../../services/AISetting'

export const getSelectAiSettingsAsync = createAsyncThunk<
  any,
  void,
  RootThunkApi<void>
>('AISettingSlice/getSelectAiSettingsAsync', async (params, api) => {
  return sendAsync(getSelectAiSettings(), api)
})


export const getSaveAiSettingsAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('AISettingSlice/getSaveAiSettingsAsync', async (params, api) => {
  return sendAsync(getSaveAiSettings(params), api)
})
